<div [formGroup]="form">
    <mat-form-field *ngIf="businessGroupList?.length" appearance="fill" class="w-full">
        <mat-label>Grupo de Socio de negocios</mat-label>
        <mat-select formControlName="businessPartnerGroupId" placeholder="Seleccione un grupo" multiple
            (selectionChange)="fetchGroup()">

            <mat-select-trigger>
                {{ businessGroupWithMongoId
                ? getDisplayValueForMongoId(businessGroupList, form.get('businessPartnerGroupId')?.value, 'name')
                : getDisplayValueForId(businessGroupList, form.get('businessPartnerGroupId')?.value, 'name')
                }}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchBusinessPartenertGroup"
                    [ngModelOptions]="{ standalone: true }" placeholderLabel="Buscar grupo de Socio de negocios..."
                    noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBusinessPartnerGroup($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let businessGroup of filteredBusinessGroupList"
                [value]="businessGroupWithMongoId ? businessGroup._id : businessGroup.id">
                <div>
                    <b class="f-9" *ngIf="getCode(businessGroup) as code">{{ code }}</b>
                </div>
                {{ businessGroup.name }}
            </mat-option>

            <mat-option *ngIf="form.get('businessPartnerGroupId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearBusinessPartnerGroup(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>


    <mat-form-field *ngIf="businessPartnerRolList?.length" appearance="fill" class="w-full">
        <mat-label>Rol del Socio de Negocio</mat-label>
        <mat-select formControlName="businessPartnerRolId" placeholder="Seleccione un rol" multiple>

            <mat-select-trigger>
                {{ getDisplayValueForCode(businessPartnerRolList, form.get('businessPartnerRolId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option *ngFor="let businessRol of businessPartnerRolList" [value]="businessRol.code">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(businessRol) as code">{{ code }}</b>
                    </div>
                    {{ businessRol.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('businessPartnerRolId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearBusinessPartnerRol(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="businessPartnerTypeList?.length" appearance="fill" class="w-full">
        <mat-label>Tipo del Socio de Negocio</mat-label>
        <mat-select formControlName="businessPartnerTypeId" placeholder="Seleccione un tipo" multiple>

            <mat-select-trigger>
                {{ getDisplayValueForCode(businessPartnerTypeList, form.get('businessPartnerTypeId')?.value, "name")}}
            </mat-select-trigger>

            <mat-option *ngFor="let businessType of businessPartnerTypeList" [value]="businessType.code">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(businessType) as code">{{ code }}</b>
                    </div>
                    {{ businessType.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('businessPartnerTypeId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearBusinessPartnerType(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="businessPartnerFilter" appearance="fill" class="w-full">
        <mat-label>Socio de negocios</mat-label>
        <mat-select formControlName="customerId" placeholder="Seleccione un socio de negocios" multiple
            (selectionChange)="filterBusinessPartnerByGroup(searchBusinessPartenert || '', $event.value)">

            <mat-select-trigger>
                {{ getDisplayValueForId(businessPartnerList, form.get('customerId')?.value, "name") }}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchBusinessPartenert" [ngModelOptions]="{standalone: true}"
                    placeholderLabel="Buscar socio de negocios..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBusinessPartnerByGroup($event, form.get('customerId')?.value)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let businessPartner of filteredBusinessPartnerList" [value]="businessPartner.id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(businessPartner) as code">{{ code }}</b>
                    </div>
                    {{ businessPartner.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('customerId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearCustomerId(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="businessPartner" appearance="fill" class="w-full">
        <mat-label>Socio de negocios</mat-label>
        <mat-select formControlName="customerId" placeholder="Seleccione un socio de negocios" multiple
            (selectionChange)="filterBusinessPartner(searchBusinessPartenert || '', $event.value)">

            <mat-select-trigger>
                {{ getDisplayValueForId(businessPartnerList, form.get('customerId')?.value, "name") }}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchBusinessPartenert" [ngModelOptions]="{standalone: true}"
                    placeholderLabel="Buscar socio de negocios..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBusinessPartner($event, form.get('customerId')?.value)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let businessPartner of filteredBusinessPartnerList" [value]="businessPartner.id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(businessPartner) as code">{{ code }}</b>
                    </div>
                    {{ businessPartner.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('customerId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearCustomerId(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="businessPartnerWithMongoId" appearance="fill" class="w-full">
        <mat-label>Socio de negocios</mat-label>
        <mat-select formControlName="customerId" placeholder="Seleccione un socio de negocios" multiple
            (selectionChange)="filterBusinessPartner(searchBusinessPartenert || '', $event.value)">

            <mat-select-trigger>
                {{ getDisplayValueForMongoId(businessPartnerList, form.get('customerId')?.value, "name") }}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="searchBusinessPartenert" [ngModelOptions]="{standalone: true}"
                    placeholderLabel="Buscar socio de negocios..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBusinessPartner($event, form.get('customerId')?.value)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let businessPartner of filteredBusinessPartnerList" [value]="businessPartner._id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(businessPartner) as code">{{ code }}</b>
                    </div>
                    {{ businessPartner.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('customerId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearCustomerId(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="payingBusinessPartner" appearance="fill" class="w-full">
        <mat-label>Socio de Negocio Pagador</mat-label>
        <mat-select formControlName="payingBusinessPartnerId" placeholder="Seleccione un socio de Negocio Pagador"
            multiple (selectionChange)="getListSoldTo(soldToControl || '')">

            <mat-select-trigger>
                {{ getDisplayValueForId(originalPayingBusinessPartnerList, form.get('payingBusinessPartnerId')?.value,
                "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search [(ngModel)]="soldToControl" [ngModelOptions]="{ standalone: true }"
                    placeholderLabel="Buscar socio de negocios pagador..."
                    noEntriesFoundLabel="No se encontraron resultados" (ngModelChange)="getListSoldTo($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let payingBusinessPartner of payingBusinessPartnerList"
                [value]="payingBusinessPartner.id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(payingBusinessPartner) as code">{{ code }}</b>
                    </div>
                    {{ payingBusinessPartner.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('payingBusinessPartnerId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearPayingBusinessPartner(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="receivingBusinessPartner" appearance="fill" class="w-full">
        <mat-label>Socio de Negocio Receptor</mat-label>
        <mat-select formControlName="receivingBusinessPartnerId" placeholder="Seleccione un socio de Negocio Receptor"
            multiple (selectionChange)="filterReceivingBusinessPartner(searchReceivingBusinessPartner || '')">

            <mat-select-trigger>
                {{ getDisplayValueForId(receivingBusinessPartnerList, form.get('receivingBusinessPartnerId')?.value,
                "name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchReceivingBusinessPartner"
                    placeholderLabel="Buscar socio de negocios receptor..."
                    noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterReceivingBusinessPartner($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let receivingBusinessPartner of filteredReceivingBusinessPartnerList"
                [value]="receivingBusinessPartner.id">
                <div class="text-sm uppercase leading-tight">
                    <div>
                        <b class="f-9" *ngIf="getCode(receivingBusinessPartner) as code">{{ code }}</b>
                    </div>
                    {{ receivingBusinessPartner.name }}
                </div>
            </mat-option>

            <mat-option *ngIf="form.get('receivingBusinessPartnerId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearReceivingBusinessPartner(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="assignedUser" appearance="fill" class="w-full">
        <mat-label>Usuario Asignado</mat-label>
        <mat-select formControlName="assignedUserId" placeholder="Seleccione un usuario asignado" multiple
            (selectionChange)="filterAssignedUserByUserName(searchAssignedUser || '')">

            <mat-select-trigger>
                {{ getDisplayValueForUserName(originalAssignedUserList, form.get('assignedUserId')?.value, "user_login_username")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchAssignedUser"
                    placeholderLabel="Buscar usuario asignado..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterAssignedUserByUserName($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.user_login_username">
                <div>
                    <b class="f-9" *ngIf="getCode(assignedUser) as code">{{ code }}</b>
                </div>
                {{ assignedUser.user_login_username }}
            </mat-option>

            <mat-option *ngIf="form.get('assignedUserId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearAssignedUser(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="assignedUserWithMongoId" appearance="fill" class="w-full">
        <mat-label>Usuario Asignado</mat-label>
        <mat-select formControlName="assignedUserId" placeholder="Seleccione un usuario asignado" multiple
            (selectionChange)="filterBusinessPartnerWithCount(searchAssignedUser || '')">

            <mat-select-trigger>
                {{ getDisplayValueMasterUserForMongoId(originalAssignedUserList, form.get('assignedUserId')?.value, "user_login_username")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchAssignedUser"
                    placeholderLabel="Buscar usuario asignado..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterBusinessPartnerWithCount($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.user_login_id">
                <div *ngIf="assignedUser.externalKeys">
                    <div *ngIf="getCode(assignedUser) as code">
                        <b class="f-10">{{ code }}</b>
                    </div>
                  </div>
                {{ assignedUser.user_login_username }}
            </mat-option>

            <mat-option *ngIf="form.get('assignedUserId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearAssignedUser(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="solicitedUser" appearance="fill" class="w-full">
        <mat-label>Usuario Solicitador</mat-label>
        <mat-select formControlName="solicitedUserId" placeholder="Seleccione un usuario solicitador" multiple
            (selectionChange)="filterAssignedUserByUserName(searchAssignedUser || '')">

            <mat-select-trigger>
                {{ getDisplayValueForUserName(originalAssignedUserList, form.get('solicitedUserId')?.value, "user_login_username")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchAssignedUser"
                    placeholderLabel="Buscar usuario solicitador..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterAssignedUserByUserName($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.user_login_username">
                <div>
                    <b class="f-9" *ngIf="getCode(assignedUser) as code">{{ code }}</b>
                </div>
                {{ assignedUser.user_login_username }}
            </mat-option>

            <mat-option *ngIf="form.get('assignedUserId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearAssignedUser(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="assignedUserByBusinessPartnerId" appearance="fill" class="w-full">
        <mat-label>Usuario Asignado</mat-label>
        <mat-select formControlName="assignedUserId" placeholder="Seleccione un usuario asignado" multiple
            (selectionChange)="filterAssignedUserBybusinessPartnerId(searchAssignedUser || '')">

            <mat-select-trigger>
                {{ getDisplayValueForUserName(originalAssignedUserList, form.get('assignedUserId')?.value, "username")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchAssignedUser"
                    placeholderLabel="Buscar usuario asignado..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterAssignedUserBybusinessPartnerId($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.business_partner_id">
                <div>
                    <b class="f-9" *ngIf="getCode(assignedUser) as code">{{ code }}</b>
                </div>
                {{ assignedUser.user_login_username }}
            </mat-option>

            <mat-option *ngIf="form.get('assignedUserId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearAssignedUser(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="assignedUserByBusinessPartnerName" appearance="fill" class="w-full">
        <mat-label>Usuario Asignado</mat-label>
        <mat-select formControlName="assignedUserId" placeholder="Seleccione un usuario asignado" multiple
            (selectionChange)="filterAssignedUserByFirstName(searchAssignedUser || '')">

            <mat-select-trigger>
                {{ getDisplayValueForUserName(originalAssignedUserList, form.get('assignedUserId')?.value, "user_login_first_name")}}
            </mat-select-trigger>

            <mat-option>
                <ngx-mat-select-search formControlName="searchAssignedUser"
                    placeholderLabel="Buscar usuario asignado..." noEntriesFoundLabel="No se encontraron resultados"
                    (ngModelChange)="filterAssignedUserByFirstName($event)">
                </ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let assignedUser of filteredAssignedUserList" [value]="assignedUser.user_login_first_name">
                <div>
                    <b class="f-9" *ngIf="getCode(assignedUser) as code">{{ code }}</b>
                </div>
                <span *ngIf="assignedUser?.user_login_first_name">{{assignedUser.user_login_first_name}} -</span> {{ assignedUser.user_login_username }}
            </mat-option>

            <mat-option *ngIf="form.get('assignedUserId')?.value?.length > 0" class="clear-option">
                <button mat-button color="warn" (click)="clearAssignedUser(); $event.stopPropagation()" class="w-full">
                    <mat-icon>clear</mat-icon>
                    Limpiar filtro
                </button>
            </mat-option>
        </mat-select>
    </mat-form-field>
</div>